import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLang } from "@/App";
import { all, pick, seq } from "@/data/images";
import Hero from "@/components/Hero";
import Foto from "@/components/Foto";
import GaleriaGrid from "@/components/GaleriaGrid";
import { Reveal, Pretitulo, TituloSeccion, BtnPrimario } from "@/components/Reveal";

export default function Eventos() {
  const { t, L } = useLang();
  const p = t.eventos;

  return (
    <div data-testid="pagina-eventos">
      <Hero pre={p.hero.pre} titulo={p.hero.titulo} fotos={[pick(p.hero.foto[0], 0) || all(p.hero.foto[0])[0]]} testid="hero-eventos" />

      {/* 2. Presentación + tipos */}
      <section className="py-20 md:py-28" data-testid="e-presentacion">
        <div className="mx-auto max-w-[1200px] px-6 md:px-10">
          <TituloSeccion pre={p.presentacion.pre} titulo={p.presentacion.titulo} />
          <Reveal className="mx-auto max-w-3xl text-center">
            <p className="text-[15.5px] leading-relaxed text-ink-soft">{p.presentacion.texto}</p>
          </Reveal>
          <div className="mt-14 grid gap-8 md:grid-cols-2 md:gap-10">
            {p.presentacion.tarjetas.map((c, i) => (
              <Reveal key={c.t} delay={i * 0.1} testid={`e-tipo-${i}`}>
                <Link to={L(c.to)} className="group block" data-testid={`e-tipo-card-${i}`}>
                  <div className="img-frame aspect-[4/3] w-full">
                    <Foto src={pick(c.foto[0], 0) || all(c.foto[0])[0]} alt={c.t} className="h-full w-full" />
                  </div>
                  <h3 className="mt-6 font-serif text-2xl font-light text-ink md:text-3xl">{c.t}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-ink-soft">{c.d}</p>
                  <span className="mt-4 inline-flex items-center gap-2 text-[11px] font-bold tracking-[0.22em] text-terra">
                    {t.global.footer.verMas}
                    <ArrowRight size={14} className="transition-transform duration-300 group-hover:translate-x-1" />
                  </span>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* 3. Espacios para cada ocasión */}
      <section className="bg-sand-deep py-20 md:py-28" data-testid="e-espacios">
        <div className="mx-auto max-w-[1300px] px-6 md:px-10">
          <TituloSeccion pre={p.espacios.pre} titulo={p.espacios.titulo} />
          <Reveal className="mx-auto mb-12 max-w-2xl text-center">
            <p className="text-[15px] text-ink-soft">{p.espacios.texto}</p>
          </Reveal>
          <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3 md:gap-5">
            {p.espacios.cards.map((c, i) => (
              <Reveal key={c.t} delay={i * 0.06} className={i >= 3 ? "lg:col-span-1" : ""} testid={`e-espacio-${i}`}>
                <Link to={L(c.to)} className="img-frame group relative block aspect-[4/2.6] w-full" data-testid={`e-espacio-card-${i}`}>
                  <Foto src={pick(c.foto[0], 0) || all(c.foto[0])[0]} alt={c.t} className="h-full w-full" />
                  <span className="pointer-events-none absolute inset-0 bg-gradient-to-t from-ink/60 via-transparent to-transparent" />
                  <span className="absolute bottom-4 left-4 text-left text-sand">
                    <span className="block font-serif text-xl md:text-2xl">{c.t}</span>
                    <span className="mt-1 block text-[11px] font-bold tracking-[0.2em] text-sand/85">{c.m2}</span>
                  </span>
                  <ArrowRight size={16} className="absolute bottom-4 right-4 text-sand transition-transform duration-300 group-hover:translate-x-1" />
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* 4. Galería */}
      <section className="py-20 md:py-28" data-testid="e-galeria">
        <div className="mx-auto max-w-[1360px] px-6 md:px-10">
          <TituloSeccion pre={p.galeria.pre} titulo={p.galeria.titulo} />
          <GaleriaEventos config={p.galeria} />
          <div className="mt-10 text-center">
            <BtnPrimario href="fotos/eventos" testid="e-galeria-ver-btn">VER GALERÍA</BtnPrimario>
          </div>
        </div>
      </section>
    </div>
  );
}

function GaleriaEventos({ config }) {
  const hero = pick(config.usar, 0) || all(config.usar)[0];
  const excl = hero ? [hero.split("/").pop()] : [];
  const fotos = [hero, ...seq(config.carpeta, 10, excl).filter((f) => f !== hero)].filter(Boolean).slice(0, 10);
  return <GaleriaGrid fotos={fotos} columnas={5} testid="e-galeria-grid" />;
}